import { useEffect, useState } from 'react';
import {
  LayoutAnimation,
  Platform,
  UIManager,
} from 'react-native';
import { CaretUp, CaretDown } from '../../../sharedComponents/Icons';
import { themeColorSet, ThemedPressable, ThemedText, ThemedView } from '@app/theme';

const Accordion = ({ id, title, isDisabled=false, content, isExpanded=false, onToggle} : {id: string, title: string, isDisabled?: boolean, content: React.ReactNode, isExpanded: boolean, onToggle?: (isExpanded: boolean) => void}) => {
  const [expanded, setExpanded] = useState(isExpanded);
  if (Platform.OS === 'android') {
    UIManager.setLayoutAnimationEnabledExperimental(true);
  }
  const toggleExpand = () => {
    if (isDisabled) return;
    LayoutAnimation.configureNext(LayoutAnimation.Presets.easeInEaseOut);
    setExpanded(!expanded);
    onToggle && onToggle(!expanded);
  };
  
  useEffect(() => {
    // onToggle && onToggle(isExpanded);
    LayoutAnimation.configureNext(LayoutAnimation.Presets.easeInEaseOut);
    setExpanded(isExpanded);
  }, [isExpanded]);

  return (
    <ThemedView bg='bg-surface-primary' key={id}>
      <ThemedPressable flexDirection='row' justifyContent='space-between' alignItems='center' backgroundColor='bg-surface-primary'  onPress={toggleExpand}>
        <ThemedView flex={1} style={{paddingHorizontal: 16}}>
          <ThemedText variant='h5s' color={isDisabled ? 'text-secondary' : 'text-primary'}>{title}</ThemedText>
        </ThemedView>
        {expanded ? (
          <CaretUp size={14} color={themeColorSet['icon-primary']} weight="bold" style={{marginRight: 16}}/>
        ) : (
          <CaretDown size={14} color={themeColorSet['icon-primary']} weight="bold" style={{marginRight: 16}}/>
        )}
      </ThemedPressable>
      {expanded && (
        content
      )}
      <ThemedView height={1} bg='border-secondary' marginVertical='lg' />
    </ThemedView>
  );
};

export default Accordion;